import { ItemsPerPage, useItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'

import { useQueryParams } from '../../../hooks/useQueryParams'
import { defaultProductsFilters } from '../constants/defaultProductsFilters'
import { ProductsFilters } from '../types/productsFilters'

type UseProductsListFiltersResponse = [ProductsFilters, (filters: Partial<ProductsFilters>) => void]

export const useProductsListFilters = (): UseProductsListFiltersResponse => {
  const [pageSize] = useItemsPerPage()

  const [queryParams, setQueryParams] = useQueryParams<ProductsFilters>({
    defaultQuery: {
      ...defaultProductsFilters,
      pageSize,
    },
  })

  return useMemo(
    () => [
      {
        ...queryParams,
        page: Number(queryParams.page),
        pageSize: Number(queryParams.pageSize) as ItemsPerPage,
      },
      setQueryParams,
    ],
    [queryParams, setQueryParams],
  )
}
